import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

const STARTER_KEYS = [
  'psalm23', 'anxiety', 'forgiveness', 'purpose', 'prayer', 'faith',
  'love', 'suffering', 'grace', 'salvation', 'holy_spirit', 'genesis',
  'beatitudes', 'armor', 'ten_cmd', 'parables',
];

export default function StarterQuestions({ onSelect }) {
  const { t } = useTranslation();
  const [visibleKeys, setVisibleKeys] = useState(() => {
    const shuffled = [...STARTER_KEYS].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 4);
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setVisibleKeys(() => {
          const shuffled = [...STARTER_KEYS].sort(() => Math.random() - 0.5);
          return shuffled.slice(0, 4);
        });
        setFading(false);
      }, 400);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center gap-3 py-4 animate-in fade-in slide-in-from-bottom-2 duration-500" data-testid="starter-questions">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="h-4 w-4" style={{ color: 'var(--theme-accent)' }} />
        <span className="text-xs font-medium tracking-wide uppercase" style={{ color: 'var(--theme-textSecondary)', opacity: 0.7 }}>
          {t('starter.try_asking')}
        </span>
      </div>
      <div
        className="flex flex-wrap justify-center gap-2 max-w-lg transition-opacity duration-400"
        style={{ opacity: fading ? 0 : 1 }}
      >
        {visibleKeys.map((key) => {
          const text = t(`starter.${key}`);
          return (
            <button
              key={key}
              onClick={() => onSelect(text)}
              className="px-4 py-2.5 rounded-2xl text-sm transition-all hover:scale-[1.03] active:scale-95 cursor-pointer"
              style={{
                background: 'var(--glass-bg)',
                border: '1px solid var(--glass-border)',
                color: 'var(--theme-text)',
                backdropFilter: 'blur(8px)',
              }}
              data-testid={`starter-q-${key}`}
            >
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
